import React from "react";

import styled from "styled-components";
import colors from "@/design/colors";
import fonts from "@/design/typography";

interface TabDefinition {
  key: string;
  label: string;
  content: React.ReactNode;
}

interface TabProps {
  tabs: TabDefinition[];
  activeKey: string;
  onChange: (key: string) => void;
}

const Tab = ({ tabs, activeKey, onChange }: TabProps) => {

  return (
    <>
      <TabWrapper>
        {tabs.map((tab) => (
          <TabItem
            key={tab.key}
            selected={tab.key === activeKey}
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
          </TabItem>
        ))}
      </TabWrapper>
      <TabContainer>
        {tabs.filter(tab => (tab.key === activeKey)).map(tab => tab.content)[0]}
      </TabContainer>
    </>
  );
};

const TabWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid ${colors.gray100};
  margin-bottom: 32px;
`;

const TabItem = styled.div<{ selected: boolean }>`
  height: 36px;
  position: relative;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  font-family: ${(props) =>
    props.selected
      ? fonts.body3SemiBold.fontFamily
      : fonts.body3Medium.fontFamily};
  font-size: ${(props) =>
    props.selected ? fonts.body3SemiBold.fontSize : fonts.body3Medium.fontSize};
  color: ${(props) => (props.selected ? colors.gray900 : colors.gray600)};
  font-weight: ${(props) => (props.selected ? 600 : 400)};

  &::after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    height: 2px;
    width: 100%;
    background-color: ${(props) =>
      props.selected ? colors.gray900 : "transparent"};
    transition: background-color 0.2s ease;
  }
`;

const TabContainer = styled.div`
  width: 100%;
`;

export default Tab;
